import React from 'react';
import {Col, Container, Row} from "react-bootstrap";
import Bannerfrom from "../components/bannerfrom";

function Banner({data}) {
    return (
        <div className="services_banner">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={6} lg={7} xl={7} xxl={7} className="my-auto">
                        <div className="banenr_content">
                            <div className="example" data-text="Events">
                                <h1>The Industry Leader In Thought Leadership Programs</h1>
                            </div>
                            <div
                                className="banner_content_txt listing_flex">
                                <p><strong>Our Learning Resources Are Primed To Keep You In Touch With The Latest Trends In The World Of Tech & Entrepreneurship.</strong></p>
                                <p><strong>Bringing The Most Talented People From The World Of Business, We Strive To Create Experiences That Stay With You and Help You Devise Actionable Insights In Order To Power Your Business Forward.</strong></p>
                            </div>

                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto ms-auto">
                        <Bannerfrom/>
                    </Col>
                </Row>
            </Container>
        </div>
    );
}

export default Banner;